import { ThirdPartyEvaluationListItem } from './thirdparty-evaluation-list-item';

export class ThirdPartyDetailItem{
    id: number = 0;
    name: string = '';
    contactUser: string = '';
    email: string = '';
    contactEmail: string = '';
    riskLevel: string = '';
    riskColor?: string = '000000'
    expirationDate: Date = null;
    currentStageName: string = '';
    currentStateOrder: number = 0;
    isActive: boolean = true;
    thirdPartyTypeId: number = 0;
    evaluations: ThirdPartyEvaluationListItem[] = [];

    constructor() {
    }
}

